import React from 'react';
import './css/InfoBlock.css'; // Common styles for info blocks
import {formatNumberWithCommas} from './formatIntegerWithCommas.js'
import { t } from 'ttag';


function EquityStakeBlock({es}) {
  return (
    <div className="info-block">
      <div className="info-block-header">{t`Equity stake`}</div>
      <div className="info-block-value">{formatNumberWithCommas(es,1)}%</div>
    </div>
  );
}

function TokenBbookBlock({amount}) {
  return (
    <div className="info-block">
      <div className="info-block-header">{t`Token BBK`}</div>
      <div className="info-block-value">{formatNumberWithCommas(amount,0)}</div>
    </div> 
  );
}

export { EquityStakeBlock, TokenBbookBlock };